import { Check, TriangleAlert, X } from "lucide-react";

export const steps = [
  { id: 1, label: "Upload" },
  { id: 2, label: "Validate" },
  { id: 3, label: "Done" },
];

export const validateCards = [
  {
    id: 1,
    count: 0,
    title: 'Total Rows',
    textClassName: 'text-primary',
    className: 'bg-primary',
    key: 'totalRows'
  },
  {
    id: 2,
    count: 0,
    title: 'Ready To Import',
    textClassName: 'text-green-600',
    className: 'bg-green-600',
    key: 'readyToImportCount'
  },
  {
    id: 3,
    count: 0,
    title: 'Rows with Error',
    textClassName: 'text-red-600',
    className: 'bg-red-600',
    key: 'errorCount'
  },
  {
    id: 4,
    count: 0,
    title: 'Rows with Warning',
    textClassName: 'text-yellow-600',
    className: 'bg-yellow-600',
    key: 'warningCount'
  }
]

export const statusOptions = [
  {
    value: 'all',
    label: 'All',
    className: 'bg-red-100',
    indicator: 'bg-red-600',
    textClassName: 'text-red-600',
    icon: X
  },
  {
    value: 'error',
    label: 'Errors',
    className: 'bg-red-100',
    indicator: 'bg-red-600',
    textClassName: 'text-red-600',
    icon: X
  },
  {
    value: 'warning',
    label: 'Warnings',
    className: 'bg-yellow-100',
    indicator: 'bg-yellow-600',
    textClassName: 'text-yellow-600',
    icon: TriangleAlert
  },
  {
    value: 'valid',
    label: 'Valid',
    className: 'bg-green-100',
    indicator: 'bg-green-600',
    textClassName: 'text-green-600',
    icon: Check
  },
]